import { render, staticRenderFns } from "./ModeloShowData.vue?vue&type=template&id=38a0da7e&"
import script from "./ModeloShowData.vue?vue&type=script&lang=js&"
export * from "./ModeloShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports